import p5 from 'p5'
import Swiper from 'swiper/bundle';
import SplitType from 'split-type'
import { elementsToMaxHeight } from '../helpers/css-formating-helpers'




// slider
function heroSlider() {

  if ($('.hero').length) {

    $('.js-scroll-down').click(() => $("html, body").animate({ scrollTop: window.innerHeight }, 600))

    // split text
    const text = new SplitType('.js-split-text', { types: 'lines' })
    $('.js-split-text .line').each(function () {
      $(this).html('<div class="js-line-animate">' + $(this).html() + '</div>')
    })

    let slideTime = 4000
    let slideTimeout = null
    let heroSwiper = new Swiper('.js-hero-slider', {
      loop: true,
      autoplay: {
        delay: slideTime,
        disableOnInteraction: false,
      },
      speed: 0,
      pagination: {
        el: ".hero-swiper-pagination",
        clickable: true,
      },
      init: false,
    })

    $(document).on('click', '.swiper-pagination-bullet', function () {
      //heroSwiper.$el.find('.swiper-slide-active').removeClass('visible')
    })

    $('.js-next-slide').click(function () {
      clearTimeout(slideTimeout)
      heroSwiper.autoplay.stop()
      heroSwiper.$el.find('.swiper-slide').removeClass('visible')
      setTimeout(function () {
        heroSwiper.slideNext();
        heroSwiper.autoplay.start()
      }, 1000)
    })
    $('.js-prev-slide').click(function () {
      clearTimeout(slideTimeout)
      heroSwiper.autoplay.stop()
      heroSwiper.$el.find('.swiper-slide').removeClass('visible')
      setTimeout(function () {
        heroSwiper.slidePrev();
        heroSwiper.autoplay.start()
      }, 1000)
    })

    heroSwiper.on('init', function () {
      heroSlideChangeAddAnimation(this.$el.find('.swiper-slide-active'))
      setTimeout(() => elementsToMaxHeight($('.js-hero-slider .swiper-slide')), 50)
    });
    heroSwiper.on('transitionEnd', function (swiper) {
      heroSlideChangeAddAnimation(this.$el.find('.swiper-slide-active'))
    });

    heroSwiper.init()

    function heroSlideChangeAddAnimation (nextSlide) {
      clearTimeout(slideTimeout)
      nextSlide.addClass('visible')
      slideTimeout = setTimeout(function () {
        heroSwiper.$el.find('.swiper-slide').removeClass('visible')
      }, slideTime - 1010)
    }

  }
}


function heroMenuHover(){
  let heroMenu = $('.hero-menu')
  $('.js-hero-menu-el').mouseenter(function() {
    heroMenu.addClass('js-hovered')
  }).mouseleave(function() {
    heroMenu.removeClass('js-hovered')
  });
}




export function heroBigAnimation() {
  let p5c = $('.js-container-p5')
  let heroSketch

  let btcPath = p5c.data('img-src')

  let sketch = function (p) {
    var containerWidth = p5c.width();
    var containerHeight = p5c.height();

    /* eslint-disable */
    p5.disableFriendlyErrors = true;
    var btc;
    var Stars = [];
    var smallSize = 100;
    let sizeCoef = 1.4
    let fromTopCoef = 2
    let logoWidth = (containerHeight * sizeCoef)
    let logoTop = containerHeight / fromTopCoef - (logoWidth / 2)

    if (window.innerWidth < 1000){
      sizeCoef = 0.6
      logoWidth = (containerWidth * 0.9)
      logoTop = -(logoWidth / 10)
    }
    if (window.innerWidth < 600){
      logoTop = 0
    }
    // if (window.innerWidth < 950){
    //   logoTop = -100
    // }
    // if (window.innerWidth < 800){
    //   logoTop = -50
    // }
    // if (window.innerWidth < 600){
    //   logoTop = -30
    // }


    var scaleFactor = logoWidth / smallSize;
    var starsColor = ['#FFFFFF', '#FDE4C7', '#FFFFFF'];

    let logoLeft = containerWidth - logoWidth - (containerWidth / 100 * -2)
    if (window.innerWidth < 1000){
      logoLeft = containerWidth / 2 - logoWidth / 2
    }

    var translate = {
      x: logoLeft,
      y: logoTop
    };
    var positions = {
      'btc': []
    };

    var RandomStars = [];

    function translatePoint (vector) {
      var newX = (vector.x * scaleFactor) + translate.x;
      var newY = (vector.y * scaleFactor) + translate.y;
      var newVec = p.createVector(newX, newY);
      return newVec;
    }

    var center = translatePoint(p.createVector(smallSize / 2, smallSize / 2));

    var bgColor = p.color('#F7931E');

    let size1 = 2
    let size2 = 5
    if (window.innerWidth < 1400){
      size2 = 4
    }
    if (window.innerWidth < 1000){
      size2 = 3
    }

    // PARTICLE OF THE IMAGE
    function Star (vector) {
      this.x = vector.x;
      this.y = vector.y;
      this.pos = p.createVector(p.random(containerWidth * -1.2, containerWidth * 1.2), p.random(containerWidth * -1.2, containerHeight * 1.2)); // initial position
      this.target = p.createVector(this.x, this.y);
      this.color = p.random(starsColor);
      this.size = p.random(size1, size2);
      this.vel = p.createVector(p.random(-5, 6), p.random(-4, 6));
      this.acc = p.createVector();
      this.maxSpeed = 10;
      this.maxForce = 2;
      this.weight = p.random(0.5, 2.5);
      this.allowRepulse = false;
      this.goingCenter = false;

      this.alpha;
    }

    Star.prototype.update = function () {
      this.pos.add(this.vel);
      this.vel.add(this.acc);
      this.alpha;
      this.acc.mult(0);
    }

    Star.prototype.move = function () {
      var attract = this.attract(this.target);
      this.appForce(attract);

      var mouse = p.createVector(p.mouseX, p.mouseY);
      var repulse = this.repulse(mouse);
      this.appForce(repulse);

    }

    Star.prototype.appForce = function (value) {
      this.acc.add(value);
    }

    Star.prototype.modAlpha = function () {
      var desired = p5.Vector.sub(this.target, this.pos);
      var d = desired.mag();
      var opacity = p.map(d, 0, 800, 255, 0);
      return opacity;
    }

    Star.prototype.attract = function (target) {
      var desired = p5.Vector.sub(target, this.pos);
      var d = desired.mag(); // distance between target and position
      if (d < 100 && !this.goingCenter) {
        // Repulse - hover uz vietas kustiba
        this.vel.limit(5); // izjauksanas atrums un jauksanas kad hoverots atrums, def=10
        if (d < 10 && !(this.allowRepulse)) { // repulse attalums def=10
          var G = 70;
          var distancesq = desired.magSq();

          var force = distancesq / G;
          desired.setMag(force * this.weight);
          this.vel.limit(.7); // burtu jauksanas daudzums
          return desired;
        }
      } else {
        // saskriesana raksta
        var G = 9999999999999999999999; // cik atri saskrien vietas
        var distancesq = desired.magSq();
        var force = G / distancesq;
        desired.setMag(force);
        this.vel.limit(15);
        return desired;
      }
    }

    // hover uz raksta
    Star.prototype.repulse = function (target) {
      var desired = p5.Vector.sub(target, this.pos);
      var d = desired.mag();
      if (d < 80) { // peles attalums no kura sak jaukt burtus. def=80
        this.allowRepulse = true;
        var distancesq = desired.magSq();
        var force = (500 / distancesq) * this.weight; // maina iztuksota cauruma lielumu uz hover def=5000
        desired.setMag(-force);
        return desired;
      } else {
        this.allowRepulse = false;
        return p.createVector(0, 0);
      }
    }

    Star.prototype.render = function () {
      p.noStroke();
      var color = p.color(this.color);
      color.setAlpha(this.modAlpha());
      p.fill(color);
      p.ellipse(this.pos.x, this.pos.y, this.size, this.size);
    }

    // FONA PUNKTI
    function RandomStar () {
      this.pos = p.createVector(p.random(containerWidth), p.random(containerHeight));
      this.vel = p.createVector(p.random(-3, 3), p.random(-3, 3));  // fona punktu kustibas atrums def= (-3,3) (-3,3)
      this.weight = p.random(0.5, 1.5);
      this.size = p.random(2, 4);
      this.corner = p.createVector(0, 0);
      this.color = p.color(p.random(starsColor));
      this.alpha;
    }

    RandomStar.prototype.modAlpha = function (dist) {
      var alpha = p.map(dist, 0, containerWidth * 0.8, 0, 255);
      return alpha;

    }

    RandomStar.prototype.checkBoundaries = function () {
      if ((this.pos.x > containerWidth) || (this.pos.x < 0)) {
        this.vel.x = this.vel.x * (-1);
      }
      if ((this.pos.y > containerHeight) || (this.pos.y < 0)) {
        this.vel.y = this.vel.y * (-1);
      }
    }

    RandomStar.prototype.update = function () {
      this.checkBoundaries();
      this.pos.add(this.vel);

      var dist = this.pos.sub(this.corner);
      this.alpha = this.modAlpha(dist.mag());
    }

    RandomStar.prototype.render = function () {
      var c = this.color;
      c.setAlpha(this.alpha);
      p.fill(c);
      p.ellipse(this.pos.x, this.pos.y, this.size, this.size);
    }

    // CREATE RANDOMSTAR
    let bgPointsCount = 200
    if (window.innerWidth < 1400) bgPointsCount = 80
    if (window.innerWidth < 1100) bgPointsCount = 30

    for (var i = 0; i < bgPointsCount; i++) { // fona punktu daudzums, def=150
      var randStar = new RandomStar();
      RandomStars.push(randStar);
    }

    let pointsPercentage = 55
    if (window.innerWidth < 1400) pointsPercentage = 35
    if (window.innerWidth < 1200) pointsPercentage = 25
    if (window.innerWidth < 900) pointsPercentage = 15

    p.setup = function () {
      p.createCanvas(containerWidth, containerHeight, 'WEBGL');
      p.pixelDensity(1);
      p.background(bgColor);
      var btc = p.loadImage(btcPath, function (img) {
        // p.image(img, 0, 0);
        btc.resize(smallSize, smallSize);
        btc.loadPixels();
        for (var x = 0; x < btc.width; x++) {
          for (var y = 0; y < btc.height; y++) {
            var index = (x + y * btc.width) * 4;
            if (btc.pixels[index] < 200) { // if channel red < 200 == black in this case
              if (Math.round(p.random(100)) < pointsPercentage) { //get only % of the points, randomly
                var initVec = p.createVector(x, y);
                var pos = translatePoint(initVec);
                positions.btc.push(pos);
                Stars.push(new Star(pos));
              }
            }
          }
        }
      }); // close callback loader image
      p.pixelDensity();
    }

    p.draw = function () {
      p.background(bgColor);
      for (var k = 0; k < Stars.length; k++) {
        Stars[k].move();
        Stars[k].update();
        Stars[k].render();
      }
      for (let j = 0; j < RandomStars.length; j++) {
        RandomStars[j].update();
        RandomStars[j].render();
      }
    }

    p.windowResized = function () {
      containerWidth = p5c.width();
      containerHeight = p5c.height();
      p.resizeCanvas(containerWidth, containerHeight);
    }

  };




  heroSketch = new p5(sketch, document.querySelector('.js-container-p5'));
  let p5Generated = 1


  $(window).scroll(function () {
    let animationC = $('.js-container-p5')
    let top = $(window).scrollTop()

    if (top > $(window).height()){
      if (p5Generated){
        heroSketch.remove()
        p5Generated = 0
      }
    } else {
      if (!p5Generated){
        if (!animationC.find('canvas').length) {
          heroSketch = new p5(sketch, document.querySelector('.js-container-p5'));
        }
        p5Generated = 1
      }
    }
  })


}


export function loadHeroIntroAnimations(){
  heroSlider()

  let timeout = 800

  setTimeout(()=>{
    $('.hero-swiper-pagination').addClass('active')
  }, timeout)

  $('.js-hero-menu-el').each(function(){
    let el = $(this)
    setTimeout(function(){
      $(el).addClass('active')
    }, timeout)
    timeout = timeout + 150
  })
}


function initHeroBlock(){
  //heroSlider()
  heroBigAnimation()
  heroMenuHover()
  //loadHeroIntroAnimations()
}
if ($('.hero').length) initHeroBlock()






